// Enhanced Sticky Add to Cart functionality
(function() {
  'use strict';

  class EnhancedStickyCart {
    constructor() {
      this.stickyBar = document.querySelector('.enhanced-sticky-bar');
      this.productGallery = document.querySelector('.product-gallery');
      this.mainProductForm = document.querySelector('form[action*="/cart/add"]');
      this.cartDrawer = document.querySelector('cart-drawer');

      if (!this.stickyBar || !this.productGallery || !this.mainProductForm) {
        return;
      }

      this.init();
    }

    init() {
      if (this.stickyBar.dataset.stickyBound === 'true') {
        // Already bound; just resync
        this.setupQuantitySync();
        return;
      }

      this.setupQuantityControls();
      this.setupVariantSelector();
      this.setupVariantSelectorClickArea();
      this.setupScrollDetection();
      this.setupAddToCartButton();
      this.syncWithMainForm();

      this.setupQuantitySync();
    }

    setupQuantityControls() {
      const mainQtyInput = document.querySelector('.product-info .product-info__block-item[data-block-id="quantity_selector"] input[name="quantity"]');

      const getStickyInputs = () => Array.from(this.stickyBar.querySelectorAll('.sticky-quantity-input'));

      let isSyncing = false;

      const normalizeQty = (value) => {
        const n = parseInt(value, 10);
        return Number.isFinite(n) && n > 0 ? n : 1;
      };

      const setMainQty = (qty) => {
        if (!mainQtyInput) return;
        mainQtyInput.value = String(qty);

        mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const setStickyQty = (qty) => {
        getStickyInputs().forEach((input) => {
          input.value = String(qty);
        });
      };

      const syncQty = (qty) => {
        if (isSyncing) return;
        isSyncing = true;

        const normalized = normalizeQty(qty);

        setMainQty(normalized);
        setStickyQty(normalized);

        isSyncing = false;
      };

      if (mainQtyInput) {
        syncQty(mainQtyInput.value);
      } else {
        syncQty(1);
      }

      this.stickyBar.addEventListener('click', (e) => {
        const minusBtn = e.target.closest('.quantity-minus');
        const plusBtn = e.target.closest('.quantity-plus');
        if (!minusBtn && !plusBtn) return;

        const current = mainQtyInput ? normalizeQty(mainQtyInput.value) : normalizeQty(getStickyInputs()[0]?.value);
        const next = minusBtn ? Math.max(1, current - 1) : current + 1;
        syncQty(next);
        this.setupAddToCartButton();
        this.setupQuantitySync();
      });

      this.stickyBar.addEventListener('input', (e) => {
        const input = e.target.closest('.sticky-quantity-input');
        if (!input) return;
        syncQty(input.value);
        this.setupAddToCartButton();
        this.setupQuantitySync();
      });

      this.stickyBar.addEventListener('change', (e) => {
        const input = e.target.closest('.sticky-quantity-input');
        if (!input) return;
        syncQty(input.value);
        this.setupAddToCartButton();
        this.setupQuantitySync();
      });

      if (mainQtyInput) {
        mainQtyInput.addEventListener('input', () => {
          if (isSyncing) return;
          setStickyQty(normalizeQty(mainQtyInput.value));
        });
        mainQtyInput.addEventListener('change', () => {
          if (isSyncing) return;
          setStickyQty(normalizeQty(mainQtyInput.value));
        });
      }
    }

    setupQuantitySync() {
      const mainInput = document.querySelector('.product-info .product-info__block-item[data-block-id="quantity_selector"] input[name="quantity"]');
      const stickyInputs = Array.from(this.stickyBar.querySelectorAll('.sticky-quantity-input'));
      if (!mainInput || !stickyInputs.length) return;

      if (this.stickyBar.dataset.qtySyncBound === 'true') return;
      this.stickyBar.dataset.qtySyncBound = 'true';

      let isSyncing = false;

      const normalize = (value) => {
        const n = parseInt(value, 10);
        return Number.isFinite(n) && n > 0 ? n : 1;
      };

      const setValueAndEvents = (el, qty) => {
        el.value = String(qty);
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const updateAll = (value, source) => {
        if (isSyncing) return;
        isSyncing = true;

        const qty = normalize(value);

        // source là sticky => main theo sticky
        if (source !== mainInput) setValueAndEvents(mainInput, qty);

        // source là main => sticky theo main
        stickyInputs.forEach((input) => {
          if (input !== source) {
            // sticky thường chỉ cần set value
            input.value = String(qty);
          }
        });

        isSyncing = false;
      };

      // main -> sticky
      mainInput.addEventListener('input', (e) => updateAll(e.target.value, mainInput));
      mainInput.addEventListener('change', (e) => updateAll(e.target.value, mainInput));

      // sticky -> main
      stickyInputs.forEach((input) => {
        input.addEventListener('input', (e) => updateAll(e.target.value, input));
        input.addEventListener('change', (e) => updateAll(e.target.value, input));
      });

      // ✅ sync lần đầu cho chắc: ưu tiên main, fallback sticky
      updateAll(mainInput.value || stickyInputs[0].value || 1, mainInput);
    }

    setupVariantSelector() {
      const mobileVariantSelect = this.stickyBar.querySelector('.sticky-variant-select');
      const desktopVariantSelect = this.stickyBar.querySelector('.sticky-variant-select-desktop');
      const variantSelectors = [mobileVariantSelect, desktopVariantSelect].filter(Boolean);
      const mainVariantInputs = this.mainProductForm.querySelectorAll('input[name="id"], select[name="id"]');
      const addToCartButton = this.stickyBar.querySelector('button[type="submit"]');
      const priceDisplay = this.stickyBar.querySelector('.sticky-price');

      if (variantSelectors.length === 0) return;

      document.addEventListener('change', (e) => {
        if (e.target.matches('select.sticky-variant-select, select.sticky-variant-select-desktop')) {
          const variantSelect = e.target;
          const selectedVariantId = variantSelect.value;
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          const isAvailable = selectedOption.dataset.available === 'true';
          const price = selectedOption.dataset.price;
          const comparePrice = selectedOption.dataset.comparePrice;

         
          variantSelectors.forEach(otherSelect => {
            if (otherSelect !== variantSelect) {
              otherSelect.value = selectedVariantId;
            }
          });


          mainVariantInputs.forEach(input => {
            if (input.type === 'hidden' || input.tagName === 'SELECT') {
              input.value = selectedVariantId;
            }
          });

          const priceDisplay = document.querySelector('.sticky-price');
          this.updateButtonState(addToCartButton, selectedVariantId, isAvailable);
          this.updatePriceDisplay(priceDisplay, price, comparePrice);

          const changeEvent = new Event('change', { bubbles: true });
          mainVariantInputs[0]?.dispatchEvent(changeEvent);
        }

        if (Array.from(mainVariantInputs).includes(e.target)) {
          const input = e.target;
          if (input.value) {
            variantSelectors.forEach(variantSelect => {
              variantSelect.value = input.value;
              const selectedOption = variantSelect.options[variantSelect.selectedIndex];
              if (selectedOption) {
                const isAvailable = selectedOption.dataset.available === 'true';
                const price = selectedOption.dataset.price;
                const comparePrice = selectedOption.dataset.comparePrice;
                
                this.updateButtonState(addToCartButton, input.value, isAvailable);
                this.updatePriceDisplay(priceDisplay, price, comparePrice);
              }
            });
          }
        }
      });

      // Initial state check
      const firstSelector = variantSelectors[0];
      if (firstSelector && firstSelector.value) {
        const selectedOption = firstSelector.options[firstSelector.selectedIndex];
        const isAvailable = selectedOption.dataset.available === 'true';
        this.updateButtonState(addToCartButton, firstSelector.value, isAvailable);
      } else {
        // No variant selected, disable button
        this.updateButtonState(addToCartButton, null, false);
      }
    }

    setupVariantSelectorClickArea() {
      // Find all variant selector containers
      const variantContainers = this.stickyBar.querySelectorAll('.sticky-variant-selector, .sticky-variant-selector-desktop');

      variantContainers.forEach(container => {
        // Ensure select is never disabled and all options are selectable
        const select = container.querySelector('select');
        if (select) {
          select.disabled = false;
          select.removeAttribute('disabled');
          select.style.pointerEvents = 'auto';
          select.style.opacity = '1';
          select.style.cursor = 'pointer';

          // Enable all options - remove disabled attribute from all options
          const options = select.querySelectorAll('option');
          options.forEach(option => {
            option.removeAttribute('disabled');
          });
        }

        // Add visual feedback on hover only
        container.addEventListener('mouseenter', () => {
          container.style.opacity = '0.8';
        });

        container.addEventListener('mouseleave', () => {
          container.style.opacity = '1';
        });
      });
    }

    updateButtonState(button, variantId, isAvailable) {
      if (!button) return;

      const buttonText = button.querySelector('.button-text');
      if (!buttonText) return;

      // Get translations from button data attributes (set by Liquid)
      const addToCartText = this.getTranslation('add_to_cart_button');
      const soldOutText = this.getTranslation('sold_out_button');
      const chooseOptionsText = this.getTranslation('choose_options');

      if (!variantId) {
        button.disabled = true;
        button.classList.add('button--disabled');
        buttonText.textContent = chooseOptionsText;
      } else if (!isAvailable) {
        button.disabled = true;
        button.classList.add('button--disabled');
        buttonText.textContent = soldOutText;
      } else {
        button.disabled = false;
        button.classList.remove('button--disabled');
        buttonText.textContent = addToCartText;
      }
    }

    getTranslation(key) {
      // Get translation from button data attributes (set by Liquid templates)
      const stickyButton = this.stickyBar.querySelector('button[type="submit"]');
      if (stickyButton) {
        const dataKey = `data-${key.replace(/[_]/g, '-')}-text`;
        const translation = stickyButton.getAttribute(dataKey);
        if (translation && translation.trim()) {
          return translation.trim();
        }
      }

      // Fallback: try to get from main form button for add to cart only
      if (key === 'add_to_cart_button') {
        const mainForm = this.mainProductForm;
        if (mainForm) {
          const submitButton = mainForm.querySelector('button[type="submit"]');
          if (submitButton) {
            const originalText = submitButton.textContent.trim();
            if (originalText &&
                !originalText.toLowerCase().includes('sold') &&
                !originalText.toLowerCase().includes('agotado') &&
                !originalText.toLowerCase().includes('unavailable') &&
                !originalText.toLowerCase().includes('choose')) {
              return originalText;
            }
          }
        }
      }

      // Final fallback: try to get from any data attribute that matches
      if (stickyButton) {
        // Try common variations of the key
        const possibleKeys = [
          `data-${key.replace(/[_]/g, '-')}-text`,
          `data-${key}-text`,
          'data-add-to-cart-text' // always fallback to add to cart
        ];

        for (const possibleKey of possibleKeys) {
          const fallbackText = stickyButton.getAttribute(possibleKey);
          if (fallbackText && fallbackText.trim()) {
            return fallbackText.trim();
          }
        }
      }

      // Ultimate fallback - should rarely be reached
      console.warn(`Translation not found for key: ${key}`);
      return 'Add to cart';
    }

    updatePriceDisplay(priceElement, price, comparePrice) {
      if (!priceElement || !price) return;

      let priceHTML = '';

      if (comparePrice) {
        priceHTML = `<span class="price-compare"><s>${comparePrice}€</s></span> <span class="price-current">${price}€</span>`;
      } else {
        priceHTML = `<span class="price-current">${price}€</span>`;
      }

      priceElement.innerHTML = priceHTML;
    }

    setupScrollDetection() {
      let ticking = false;

      const stickyBars = Array.from(document.querySelectorAll('.enhanced-sticky-cart'));

      const update = () => {
        const isMobile = window.innerWidth <= 699;

        if (isMobile) {
          stickyBars.forEach(bar => bar.classList.add('is-visible'));
          document.body.classList.add('sticky-cart-visible');
          ticking = false;
          return;
        }

        document.body.classList.remove('sticky-cart-visible');

        stickyBars.forEach(bar => {
          // Tìm scope gần nhất (đổi selector này cho đúng theme của bạn)
          const scope = bar.closest('[data-section-id]') || document;

          const gallery = scope.querySelector('.product__media, .product-gallery, [data-product-gallery]');
          const form = scope.querySelector('form[action*="/cart/add"], .product-form');

          if (!gallery || !form) {
            bar.classList.remove('is-visible');
            return;
          }

          const galleryRect = gallery.getBoundingClientRect();

          const buyButtons =
            form.querySelector('buy-buttons') ||
            form.querySelector('[data-buy-buttons]') ||
            form.querySelector('button[name="add"]') ||
            form.querySelector('button[type="submit"]');

          const target = buyButtons || form;
          const targetRect = target.getBoundingClientRect();

          const shouldShow = galleryRect.bottom < 100 && targetRect.bottom < 0;
          bar.classList.toggle('is-visible', shouldShow);
        });

        ticking = false;
      };

      const onScrollOrResize = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize, { passive: true });

      update();
    }

    setupAddToCartButton() {
      const addToCartButton = this.stickyBar.querySelector('button[type="submit"]');
      if (!addToCartButton) return;

      if (addToCartButton.dataset.bound === 'true') return;
      addToCartButton.dataset.bound = 'true';

      // Replace the click handler inside setupAddToCartButton()

      addToCartButton.addEventListener('click', async (e) => {
        e.preventDefault();

        const formEl = this.mainProductForm;
        const formData = new FormData(formEl);

        const variantId = formData.get('id');
        if (!variantId) {
          this.showError('Please choose a variant');
          return;
        }

        const stickyQtyInput = this.stickyBar.querySelector('input[name="quantity"]');
        const quantity = Number(stickyQtyInput?.value || 1);
        formData.set('quantity', String(quantity));

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          })
        );

        formData.set('sections', sectionsToBundle.join(','));
        formData.set('sections_url', `${Shopify.routes.root}variants/${variantId}`);

        addToCartButton.classList.add('loading');
        addToCartButton.disabled = true;

        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest' // Important for Shopify inventory checks (matches theme)
            }
          });

          const responseJson = await response.json();

          if (!response.ok) {
            this.showError(responseJson?.description || responseJson?.message || 'Error adding to cart');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return;
          }

          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent.sections = responseJson.sections;

          formEl.dispatchEvent(
            new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items: responseJson.items ? responseJson.items : [responseJson],
                cart: cartContent,
                onSuccessDo: formData.get('on_success')
              }
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                onSuccessDo: formData.get('on_success'),
                cart: cartContent
              }
            })
          );

          // Open drawer (theme uses show())
          if (this.cartDrawer && typeof this.cartDrawer.show === 'function') {
            this.cartDrawer.show();
          }
        } catch (err) {
          console.error('Error adding to cart:', err);
          this.showError('Error adding to cart');
        } finally {
          addToCartButton.classList.remove('loading');
          addToCartButton.disabled = false;
        }
      });
    }

    getFormProperties(formData) {
      const properties = {};
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const propName = key.match(/properties\[(.*)\]/)[1];
          properties[propName] = value;
        }
      }
      return properties;
    }

    showSuccess() {
      // Create a temporary success notification
      const notification = document.createElement('div');
      notification.className = 'sticky-cart-notification success';
      notification.innerHTML = `
        <div class="notification-content">
          Added to cart!
        </div>
      `;

      document.body.appendChild(notification);

      // Add styles
      Object.assign(notification.style, {
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: '#10b981',
        color: 'white',
        padding: '12px 16px',
        borderRadius: '8px',
        zIndex: '9999',
        transform: 'translateX(100%)',
        transition: 'transform 0.3s ease'
      });

      // Animate in
      setTimeout(() => {
        notification.style.transform = 'translateX(0)';
      }, 10);

      // Remove after 3 seconds
      setTimeout(() => {
        notification.style.transform = 'translateX(100%)';
        setTimeout(() => {
          notification.remove();
        }, 300);
      }, 3000);
    }

    showError(message) {
      console.error('Cart error:', message);
      // You could implement error notification similar to showSuccess
    }

    openCartDrawer() {
      // Try to open cart drawer if it exists
      if (this.cartDrawer && typeof this.cartDrawer.open === 'function') {
        this.cartDrawer.open();
      } else {
        // Fallback: trigger cart drawer open event
        const cartToggle = document.querySelector('[aria-controls="cart-drawer"]');
        if (cartToggle) {
          cartToggle.click();
        }
      }
    }

    syncWithMainForm() {
      // Keep sticky bar in sync with main product form changes
      const observer = new MutationObserver(() => {
        // Re-sync form values when the main form changes
        const mainVariantInput = this.mainProductForm.querySelector('input[name="id"]');
        const stickyVariantSelect = this.stickyBar.querySelector('.sticky-variant-select');

        if (mainVariantInput && stickyVariantSelect) {
          stickyVariantSelect.value = mainVariantInput.value;
        }
      });

      observer.observe(this.mainProductForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new EnhancedStickyCart();
    });
  } else {
    new EnhancedStickyCart();
  }

})();